(ns manage.content-configuration-page.context-source.manual-split-testing
  (:require ["@mui/material/Stack$default" :as Stack]
            [common.ui.list :as ui.list]
            [common.ui.store :as store]
            [common.util :refer [percentage]]
            [manage.content-configuration-page.context-source.shared :as cs]
            [manage.content-configuration-page.view.input :as view.input]
            [manage.content-configuration-page.view.list :as lv]
            [re-frame.core :as rf]
            [re-posh.core :as rp]
            [reagent.core :as r]
            [uix.core :refer [$]]))

(def schema-id "urn:lemonpi:schema:context:split-testing:v2")

;; database

(defn db-create-split-test-split
  [stcs id weight]
  {:split-test-split/id id
   :split-test-split/weight weight
   :split-test-split/owner-id stcs})

(rp/reg-event-ds :split-test-split/create
  (fn [_ [_ stcs id]]
    [{:db/id stcs :manual-split-testing-context-source/split
      [(db-create-split-test-split stcs id 1)]}]))

(rp/reg-query-sub :split-test-split/other-split-weights
  '[:find ?s ?w ; posh does not support (sum ?w) :-(
    :in $ ?current-split
    :where
    [?st :manual-split-testing-context-source/split ?current-split]
    [?st :manual-split-testing-context-source/split ?s]
    [?s :split-test-split/weight ?w]
    [(!= ?s ?current-split)]])

(rf/reg-sub :manual-split-testing-context-source/suggest-split-test-split-id
  (fn [[_ stcs]]
    (store/entity stcs [{:manual-split-testing-context-source/split [:split-test-split/id]}]))
  (fn [{splits :manual-split-testing-context-source/split} _]
    (letfn [(next-char [c] (char (inc (.charCodeAt c))))]
      (reduce (fn [result {split-id :split-test-split/id}]
                (cond-> result
                  (= split-id result) next-char))
              "A" (sort-by :split-test-split/id splits)))))

(rf/reg-sub :split-test-split/weight-percentage
  (fn [[_ split _entered-weight]]
    (rf/subscribe [:split-test-split/other-split-weights split]))
  (fn [other-split-weights [_ _split entered-weight]]
    (percentage (/ entered-weight
                   (apply + entered-weight (map second other-split-weights))))))

(defmethod cs/parameter schema-id
  [{splits :manual-split-testing-context-source/split}]
  {:type :manual
   :options {:split (map (fn [{:split-test-split/keys [id weight] s :db/id}]
                           {:value id
                            :weight weight
                            :label (str id " (" @(rf/subscribe [:split-test-split/weight-percentage s weight]) ")")})
                         splits)}})

(defmethod cs/context->constructor schema-id
  [{:keys [alias param]}]
  {:manual-split-testing-context-source/split
   (map (fn [{:keys [value weight]}]
          (db-create-split-test-split [:context-source/alias alias] value weight))
        (get-in param [:options :split]))})

;; UI

(defn split-weight [s]
  (r/with-let [weight (r/atom @(store/get-value s :split-test-split/weight))
               disabled? @(rf/subscribe [:resource.content-function-version/active-version? "published"])]
    [:> Stack
     {:direction "row"
      :alignItems "center"
      :gap 1}
     [:p "Weight"]
     [view.input/input-save-on-change
      (merge-with merge
                  (view.input/props-input-integer s :split-test-split/weight)
                  {:on-change (partial reset! weight)
                   :validation/stages #{:save-blocking :warning :publish-blocking}
                   :form-field-props {:sx #js {:flexGrow 1}}
                   :control-props {:inputProps #js {:min 1} :disabled disabled?}})]
     [:p @(rf/subscribe [:split-test-split/weight-percentage (:eid s) @weight])]]))

(defn entity-view-cfg-split-test-split [s]
  {:entity/ref s
   :entity/label :split-test-split/id
   :list-item/details [split-weight s]})

(defmethod cs/entity-view-cfg schema-id
  [stcs]
  (merge
   (cs/entity-view-cfg-base stcs)
   {:list-item/details [cs/configure-button stcs "call_split" "Configure split testing"]
    :entity/read-only? false
    :entity/query-param [:context-source/query-params stcs]
    :entity/content
    [lv/view
     {:entity/ref stcs
      :list/add-item-cfg
      {:add-item/label "Add split"
       :add-item/new-value [:manual-split-testing-context-source/suggest-split-test-split-id stcs]
       :add-item/add-fn #(rf/dispatch [:split-test-split/create (:eid stcs) %])}
      :list/items :manual-split-testing-context-source/split
      :list/->item-cfg entity-view-cfg-split-test-split
      :list/empty-msg ($ ui.list/empty-msg {:title "Add a split to your test"}
                         ($ :p
                            "Splits are the different possible outcomes of your split-test.
                             Once a split is added, you can define the weight of that
                             split to control the split distribution.")
                         ($ :p
                            "Added splits can be used as a trigger in your rules to
                             trigger certain content."))}]}))

(defmethod cs/entity-query-params schema-id
  [{:keys [alias]}]
  (cs/alias->entity-query-params alias))
